var exports = {
  "A": "x61f99309--25e48a--stars-container",
};

module.exports = exports;
